import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Apply: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    fill='none'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <clipPath id='a'>
      <path d='m0 0h24v24h-24z' />
    </clipPath>
    <g clipPath='url(#a)'>
      <path
        clipRule='evenodd'
        d='m0 10.008v10.008h3 3v-1.008-1.008h-1.992-1.992v-6-6h9.984 9.984v3 3h1.0079 1.008l.0061 4.002c.0034 2.2011.0088-.4989.0121-6l.0059-10.002h-12.012-12.012zm.01188.012c0 5.5044.00276 7.7526.00612 4.996.00336-2.7565.00336-7.26014 0-10.00797-.00336-2.74781-.00612-.49243-.00612 5.01197zm2.00412-7.02v.984h9.984 9.984v-.984-.984h-9.984-9.984zm10.008 10.5098-3.924 1.5802v2.589 2.589h1.008 1.008l.0062-1.2805c.0058-1.2055.0087-1.2796.048-1.2649.023.0086.2712.1083.5517.2216l.5098.2061.0062 1.8011.0061 1.8011 2.052.9618c1.1286.529 2.1987 1.0304 2.3781 1.1142l.326.1525 2.386-1.1167 2.3859-1.1166.012-1.806.012-1.806 1.5543-.6239 1.5543-.624-.0063-.9002-.0063-.9002-3.9-1.5689c-2.145-.863-3.9324-1.5735-3.972-1.5789-.0541-.0075-1.0497.3837-3.996 1.5702zm1.632 1.5141c-1.2738.5127-2.3305.9412-2.3482.9523-.0213.0134.771.3433 2.328.9695l2.3602.9493 2.3674-.9495c1.3578-.5446 2.3546-.9569 2.3374-.9668-.0551-.0317-4.6909-1.8907-4.71-1.8888-.0104.0011-1.061.4214-2.3348.934zm-.4023 4.6936.0063.7571 1.356.6374c.7458.3505 1.3668.6376 1.38.638.0132.0003.6423-.2891 1.398-.6432l1.374-.6437v-.7515c0-.4134-.0051-.7516-.0113-.7516-.0061 0-.6289.2484-1.3838.552l-1.3726.552-1.2501-.5021c-.6876-.2761-1.3071-.5245-1.3765-.5518l-.1264-.0497z'
        fill={fill}
        fillRule='evenodd'
      />
    </g>
  </svg>
)

export default Apply
